// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__JaD0y","Layout__container":"Layout_Layout__container__sd7tW"};